// Loader Leaflet + plugin Leaflet.Marker.SlideTo dari CDN (sekali per halaman, aman utk StrictMode).
let _p = null;

const addScript = (src) => new Promise((resolve, reject) => {
  const s = document.createElement("script");
  s.src = src;
  s.async = false;
  s.onload = resolve;
  s.onerror = reject;
  document.body.appendChild(s);
});

export const loadLeaflet = () => {
  if (window.L?.Marker?.prototype?.slideTo) return Promise.resolve(window.L);
  if (_p) return _p;
  const css = document.createElement("link");
  css.rel = "stylesheet";
  css.href = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
  document.head.appendChild(css);
  _p = (window.L ? Promise.resolve() : addScript("https://unpkg.com/leaflet@1.9.4/dist/leaflet.js"))
    .then(() => addScript("https://unpkg.com/leaflet.marker.slideto@0.3.0/Leaflet.Marker.SlideTo.js").catch(() => {}))
    .then(() => window.L);
  return _p;
};

// Gerakkan marker armada secara halus ke posisi baru (fallback lompat bila plugin gagal dimuat).
export const moveMarker = (marker, latlng, duration = 2500) => {
  if (!marker) return;
  const cur = marker.getLatLng();
  if (cur && cur.lat === latlng[0] && cur.lng === latlng[1]) return;
  if (typeof marker.slideTo === "function") marker.slideTo(latlng, { duration, keepAtCenter: false });
  else marker.setLatLng(latlng);
};

// Putar ulang titik-titik baru berurutan dgn kecepatan konstan selama totalMs (gerak terus, tidak lompat).
export const playPath = (marker, pts, totalMs) => {
  if (!marker || !pts.length) return;
  clearTimeout(marker._gacPlay);
  if (typeof marker.slideTo !== "function") { marker.setLatLng(pts[pts.length - 1]); return; }
  let prev = marker.getLatLng();
  const segs = pts.map((p) => { const d = prev.distanceTo(p); prev = window.L.latLng(p); return { p, d }; });
  const total = segs.reduce((a, s) => a + s.d, 0) || 1;
  let i = 0;
  const step = () => {
    if (i >= segs.length) return;
    const { p, d } = segs[i++];
    const ms = Math.max(200, (d / total) * totalMs);
    marker.slideTo(p, { duration: ms, keepAtCenter: false });
    marker._gacPlay = setTimeout(step, ms);
  };
  step();
};

// Arah (derajat dari utara, searah jarum jam) dari a ke b; null bila geser < 3 m (noise GPS).
export const bearingDeg = (a, b) => {
  const A = window.L.latLng(a), B = window.L.latLng(b);
  if (A.distanceTo(B) < 3) return null;
  const r = Math.PI / 180;
  const y = Math.sin((B.lng - A.lng) * r) * Math.cos(B.lat * r);
  const x = Math.cos(A.lat * r) * Math.sin(B.lat * r) - Math.sin(A.lat * r) * Math.cos(B.lat * r) * Math.cos((B.lng - A.lng) * r);
  return (Math.atan2(y, x) / r + 360) % 360;
};

// Marker mobil tampak atas yg diputar halus mengikuti arah jalan (haluan selalu ke depan).
export const headingMarker = (L, latlng, iconUrl, w = 30, h = 57) => {
  const icon = L.divIcon({
    className: "gac-heading-icon",
    html: `<img src="${iconUrl}" style="width:${w}px;height:${h}px;transform:rotate(0deg);transition:transform .8s ease-out;filter:drop-shadow(0 2px 3px rgba(0,0,0,.35))" />`,
    iconSize: [w, h], iconAnchor: [w / 2, h / 2], popupAnchor: [0, -h / 2],
  });
  const m = L.marker(latlng, { icon });
  let cur = 0;
  m._gacOnHeading = (deg) => {
    const img = m.getElement()?.querySelector("img");
    if (!img) return;
    cur += ((deg - cur + 540) % 360) - 180;   // putar lewat sudut terpendek
    img.style.transform = `rotate(${cur}deg)`;
  };
  return m;
};

// Realtime: titik baru masuk antrean; tiap titik diluncurkan selama jeda waktu antar titik
// (gerak mulus konstan, tertinggal ±1 jeda kiriman). Antrean menumpuk → dipercepat.
export const enqueueMove = (marker, pt, tsMs) => {
  const q = (marker._gacQ ||= []);
  const gap = marker._gacTs && tsMs > marker._gacTs ? tsMs - marker._gacTs : 2000;   // titik pertama: kejar cepat
  marker._gacTs = tsMs;
  const from = q.length ? q[q.length - 1].p : marker.getLatLng();
  q.push({ p: pt, ms: Math.min(20000, Math.max(1500, gap)), bearing: bearingDeg(from, pt) });
  if (!marker._gacBusy) runQueue(marker);
};
const runQueue = (marker) => {
  const q = marker._gacQ;
  if (!q.length) { marker._gacBusy = false; return; }
  marker._gacBusy = true;
  clearTimeout(marker._gacPlay);
  if (q.length > 20) { const last = q[q.length - 1].p; q.length = 0; marker.setLatLng(last); marker._gacBusy = false; return; }
  const { p, ms, bearing } = q.shift();
  const dur = q.length >= 2 ? ms / q.length : ms;   // tertinggal ≥ 2 titik → percepat
  if (bearing != null) marker._gacOnHeading?.(bearing);
  if (typeof marker.slideTo === "function") marker.slideTo(p, { duration: dur, keepAtCenter: false });
  else marker.setLatLng(p);
  marker._gacPlay = setTimeout(() => runQueue(marker), dur);
};

export const fmtRouteEta = (r) => (r ? `± ${r.eta_min} menit · ${(r.distance_m / 1000).toFixed(1).replace(".", ",")} km` : "");
